const EMAIL_FORMAT = /^([a-z0-9_+.\-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
const NAME_SPECIAL_CHARS = /[^a-z0-9 ]/i;

export function validateEmail(value) {
    if (!value) return 'Please enter your E-mail';

    if (value.length < 5) return 'E-mail is too short';

    const lettersOnly = value.replace(/[^a-z]+/g, '');
    if (!lettersOnly && value.indexOf('@') >= 0) {
        return 'E-mail must contain letters';
    }

    if (!EMAIL_FORMAT.test(value)) return 'E-mail is not valid';
}

export function validateName(value) {
    if (!value) return 'Please enter your Name';

    if (value.length < 2) return 'Field must contain at least 2 characters';

    const withoutDigits = value.replace(/[0-9]+/g, '');
    if (value.length !== withoutDigits.length) {
        return 'Field must contain only letters.';
    }

    if ((value.match(/ /g) || []).length > 3) {
        return 'Field must contain only letters.';
    }

    const cleaned = value.replace(/[-\u2013\u2014]/g, '');
    if (NAME_SPECIAL_CHARS.test(cleaned)) {
        return 'Field must contain only letters.';
    }
}

export function validatePhone(value) {
    if (!value) return 'Please enter your Phone';

    const digitsOnly = value.replace(/[^0-9]+/g, '');
    if (digitsOnly !== value.toString()) return 'Phone number not valid';

    if (value.length < 4) return 'Phone number is too short';
    if (value.length > 20) return 'Phone number not valid';
}

export function validatePhoneCode(value, countries) {
    if (!value) return 'Please enter valid Country code';
    if (!countries) return 'Incorrect country code.';

    const code = value.replace('+', '');
    const exists = Object.values(countries).some(c => String(c.phoneCode) === code);
    if (!exists) return 'Incorrect country code.';
}

export function validatePassword(value) {
    if (!value) return 'Please enter your Password';
}

export function validateFilesRequired(files, selectedItems, itemsConfig) {
    const needsFile = Object.entries(itemsConfig).some(([key, config]) => {
        return config.fileRequired && selectedItems.includes(key) && (!files || files.length === 0);
    });

    if (needsFile) return 'Please upload your existing files';
}

export function validateStep1(values) {
    const errors = {};

    if (!values.careerLevel || values.careerLevel <= 0) {
        errors.careerLevel = 'Please select career level';
    }

    if (!values.urgency || values.urgency <= 0) {
        errors.urgency = 'Please select urgency';
    }

    const hasServices = values.services && values.services.length > 0;
    const hasFeatures = values.features && values.features.length > 0;
    if (!hasServices && !hasFeatures) {
        errors.services = 'Please choose services to proceed';
    }

    return errors;
}
